import Controller from "./class.Controller.js";

let ENABLED = true;

export default class TransporterLog extends Controller {
	constructor(options) {
		super(options);
		this.prefix = [`%c${this.name}:`, `color: ${this.color}; font-size: 12px;`];
	}

	log(...n) {
		if (this._isEnabled()) {
			console.log(...this.prefix, ...n);
		}
	}

	warn(...n) {
		if (this._isEnabled()) {
			console.warn(...this.prefix, ...n);
		}
	}

	error(...n) {
		if (this._isEnabled()) {
			console.error(...this.prefix, ...n);
		}
		const dataStringified = this.prepError(n);
		console.error(`E_TRANSPORTER`, `${this.name}: ${dataStringified}`, {
			name: this.name,
			args: n,
		});
	}

	prepError(arr) {
		let result = "";
		for (let item of arr) {
			if (_.isString(item)) {
				result += `${item} `;
			} else {
				try {
					result += `${JSON.stringify(item)} `;
				} catch (e) {
					result += `${item} `;
				}
			}
		}
		return result.trim();
	}

	_isEnabled() {
		return ENABLED;
	}

	_setEnabled(val) {
		ENABLED = !!val;
	}
}
